import moment from 'moment'

export const URL_SPAN = '/rest/span'
export interface SpanType {
    timestamp: number
    start: number
    end: number
    explained: string
    includesPresent: boolean
    isFixed: boolean
}

export const getSpanByExpression = (expression: string): SpanType => {
    const xhr = new XMLHttpRequest()
    xhr.open('POST', URL_SPAN, false)
    xhr.setRequestHeader('Content-Type', 'application/json;charset=utf-8')
    xhr.send(JSON.stringify({ expression: expression }))
    return JSON.parse(xhr.response)
}

export const getDashboardFilters = (selectedDashboard: Dashboard): Record<string, string> => {
    if (!selectedDashboard || !selectedDashboard?.filter || selectedDashboard?.filter.trim() == '') return {}
    const url = new URL(` http://url${selectedDashboard?.filter}`)
    const searchParams = new URLSearchParams(url.search)
    let obj = {}
    for (const p of searchParams) {
        obj = {
            ...obj,
            [p[0]]: p[1]
        }
    }
    return obj
}

export const getModifiedSpan = (
    dashboard: Dashboard,
    spanText: string,
    callFromActiveNode: boolean
): { span: string; multipleSpanPicker: string } => {
    let obj = { span: spanText, multipleSpanPicker: `{"time":"${spanText}"}` }
    const spanConfig = getSpanByExpression(spanText)
    if (dashboard.type.toLowerCase() === 'time') {
        if (spanConfig.includesPresent) {
            if (spanText && spanText.length > 0) {
                obj['span'] = `tz '${moment.tz.guess()}' ${spanText}`
            } else {
                obj['span'] = `24 hours before now`
            }
        } else {
            obj['span'] = `tz '${moment.tz.guess()}' ${moment(spanConfig.start).format('YYYY-MM-DD HH:mm')} to ${moment(
                spanConfig.end
            ).format('YYYY-MM-DD HH:mm')}`
        }
        obj['multipleSpanPicker'] = `{"time":"${obj['span']}"}`
    } else if (dashboard.type.toLowerCase() === 'depth') {
        const start = spanConfig.start && spanConfig.start >= 0 ? spanConfig.start : 0
        const end = spanConfig.end && spanConfig.end >= 0 ? spanConfig.end : 0
        obj['span'] = `ts ${start} to ts ${end}`
        obj['multipleSpanPicker'] = `{"depth":"${obj['span']}"}`
        if (callFromActiveNode) {
            obj['refreshRate'] = 5
            obj['useLastAssetDepth'] = 'false'
            obj['selectedOption'] = 'last'
            obj['selectedMeasurementOption'] = 'MD'
            if (dashboard.defaultDataRequestRange && dashboard.defaultDataRequestRange.unitOf === 'depth') {
                obj['range'] = dashboard.defaultDataRequestRange['range']
                obj['rangeAhead'] = '100'
                obj['pickerUnit'] = 'ft'
            }
        } else {
            obj['useLastAssetDepth'] = 'false'
            obj['selectedOption'] = 'from'
        }
    }
    return obj

    // if (dashboardLabel.includes('[TIME]')) {
    //     const spanConfig = getSpanByExpression(spanText)
    //     if (!spanConfig.includesPresent) {
    //         if (moment(spanConfig.end) > moment()) {
    //             obj['span'] = `${moment().subtract(24, 'hours').format('YYYY-MM-DD HH:mm')} to now`
    //         } else {
    //             obj['span'] = `${moment(spanConfig.end).subtract(24, 'hours').format('YYYY-MM-DD HH:mm')} to ${moment(
    //                 spanConfig.end
    //             ).format('YYYY-MM-DD HH:mm')}`
    //         }
    //     }
    //     obj['multipleSpanPicker'] = `{"time":"${obj['span']}"}`
    //     return obj
    // } else {
    //     if (dashboardType.toLowerCase() == 'depth') {
    //         const spanConfig = getSpanByExpression(spanText)
    //         obj['span'] = `ts ${spanConfig.start > 0 ? spanConfig.start : 0} to ts ${spanConfig.end}`
    //         obj['multipleSpanPicker'] = `{"depth":"${obj['span']}"}`
    //     }
    //     return obj
    // }
}
